import _ from "lodash";

import * as Api from "@modules/api";
import { thunkErrorHandler } from "@utils/helpers/thunkErrorHandler";
import { thunkResponseCheckerSdk } from "@utils/helpers/thunkResponseCheckerSdk";
import { ApiMethod } from "@utils/types/common";

import {
  LibraryItemWithProgressOutput,
  LibraryProgressListContentInput,
} from "./types";
// import { getPublicMediaUrl } from "@modules/api/util/mediaHelper";

export const getStarted: ApiMethod<
  LibraryProgressListContentInput,
  {
    data: LibraryItemWithProgressOutput[];
    meta: {
      hasNextPage: boolean | undefined;
      totalCount: number | undefined;
      currentPage: number | undefined;
    };
  }
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Api.Server.Server_ContentEntities_Client(
        undefined,
        Api.apiClient
      );

      const response = await client.contentEntities_myStarted_get_V1(
        "1",
        body.SortBy,
        body.Type,
        body.TypeId,
        body.PageNumber,
        body.PageSize
      );

      if (response.success && response.data) {
        const { hasNextPage, totalCount, currentPage } = response;

        const dataObj = _.reduce(
          response.data,
          function (
            obj: { [key: string]: LibraryItemWithProgressOutput },
            param
          ) {
            if (param.id) obj[param.id] = param;

            return obj;
          },
          {}
        );

        const client = new Api.Server.Server_Sessions_Client(
          undefined,
          Api.apiClient
        );

        const progressResponse =
          await client.sessions_myContentProgresses_post_V1({
            contentEntityIds: response.data.map((l) => l.id!),
          });

        if (progressResponse.success && progressResponse.data) {
          for (const progress of progressResponse.data) {
            if (dataObj[progress.contentEntityId!]) {
              dataObj[progress.contentEntityId!] = {
                ...dataObj[progress.contentEntityId!],
                progress: progress.currentProgress,
              };
            }
          }

          return {
            data: Object.values(dataObj),
            meta: {
              hasNextPage,
              totalCount,
              currentPage,
            },
          };
        }

        return rejectWithValue(progressResponse.errors);
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const getCompleted: ApiMethod<
  LibraryProgressListContentInput,
  {
    data: LibraryItemWithProgressOutput[];
    meta: {
      hasNextPage: boolean | undefined;
      totalCount: number | undefined;
      currentPage: number | undefined;
    };
  }
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Api.Server.Server_ContentEntities_Client(
        undefined,
        Api.apiClient
      );

      const response = await client.contentEntities_myCompleted_get_V1(
        "1",
        body.SortBy,
        body.Type,
        body.TypeId,
        body.PageNumber,
        body.PageSize
      );

      if (response.success && response.data) {
        const { hasNextPage, totalCount, currentPage } = response;

        const dataObj = _.reduce(
          response.data,
          function (
            obj: { [key: string]: LibraryItemWithProgressOutput },
            param
          ) {
            if (param.id) obj[param.id] = param;

            return obj;
          },
          {}
        );

        const client = new Api.Server.Server_Sessions_Client(
          undefined,
          Api.apiClient
        );

        const progressResponse =
          await client.sessions_myContentProgresses_post_V1({
            contentEntityIds: response.data.map((l) => l.id!),
          });

        if (progressResponse.success && progressResponse.data) {
          for (const progress of progressResponse.data) {
            if (dataObj[progress.contentEntityId!]) {
              dataObj[progress.contentEntityId!] = {
                ...dataObj[progress.contentEntityId!],
                progress: progress.currentProgress,
              };
            }
          }

          return {
            data: Object.values(dataObj),
            meta: {
              hasNextPage,
              totalCount,
              currentPage,
            },
          };
        }

        return rejectWithValue(progressResponse.errors);
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const getFavorite: ApiMethod<
  LibraryProgressListContentInput,
  {
    data: LibraryItemWithProgressOutput[];
    meta: {
      hasNextPage: boolean | undefined;
      totalCount: number | undefined;
      currentPage: number | undefined;
    };
  }
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Api.Server.Server_ContentEntities_Client(
        undefined,
        Api.apiClient
      );

      const response = await client.contentEntities_myFollowed_get_V1(
        "1",
        body.SortBy,
        body.Type,
        body.TypeId,
        body.PageNumber,
        body.PageSize
      );

      if (response.success && response.data) {
        const { hasNextPage, totalCount, currentPage } = response;

        const dataObj = _.reduce(
          response.data,
          function (
            obj: { [key: string]: LibraryItemWithProgressOutput },
            param
          ) {
            if (param.id) obj[param.id] = param;

            return obj;
          },
          {}
        );

        const client = new Api.Server.Server_Sessions_Client(
          undefined,
          Api.apiClient
        );

        const progressResponse =
          await client.sessions_myContentProgresses_post_V1({
            contentEntityIds: response.data.map((l) => l.id!),
          });

        if (progressResponse.success && progressResponse.data) {
          for (const progress of progressResponse.data) {
            if (dataObj[progress.contentEntityId!]) {
              dataObj[progress.contentEntityId!] = {
                ...dataObj[progress.contentEntityId!],
                progress: progress.currentProgress,
              };
            }
          }

          return {
            data: Object.values(dataObj),
            meta: {
              hasNextPage,
              totalCount,
              currentPage,
            },
          };
        }

        return rejectWithValue(progressResponse.errors);
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const getBookmarked: ApiMethod<
  LibraryProgressListContentInput,
  {
    data: LibraryItemWithProgressOutput[];
    meta: {
      hasNextPage: boolean | undefined;
      totalCount: number | undefined;
      currentPage: number | undefined;
    };
  }
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Api.Server.Server_ContentEntities_Client(
        undefined,
        Api.apiClient
      );

      const response =
        await client.contentEntities_myBookmarkedContainer_get_V1(
          "1",
          body.SortBy,
          body.PageNumber,
          body.PageSize
        );

      if (response.success && response.data) {
        const { hasNextPage, totalCount, currentPage } = response;

        const dataObj = _.reduce(
          response.data,
          function (
            obj: { [key: string]: LibraryItemWithProgressOutput },
            param
          ) {
            if (param.id) obj[param.id] = param;

            return obj;
          },
          {}
        );

        const client = new Api.Server.Server_Sessions_Client(
          undefined,
          Api.apiClient
        );

        const progressResponse =
          await client.sessions_myContentProgresses_post_V1({
            contentEntityIds: response.data.map((l) => l.id!),
          });

        if (progressResponse.success && progressResponse.data) {
          for (const progress of progressResponse.data) {
            if (dataObj[progress.contentEntityId!]) {
              dataObj[progress.contentEntityId!] = {
                ...dataObj[progress.contentEntityId!],
                progress: progress.currentProgress,
              };
            }
          }

          return {
            data: Object.values(dataObj),
            meta: {
              hasNextPage,
              totalCount,
              currentPage,
            },
          };
        }

        return rejectWithValue(progressResponse.errors);
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const getHighlighted: ApiMethod<
  LibraryProgressListContentInput,
  {
    data: LibraryItemWithProgressOutput[];
    meta: {
      hasNextPage: boolean | undefined;
      totalCount: number | undefined;
      currentPage: number | undefined;
    };
  }
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Api.Server.Server_ContentEntities_Client(
        undefined,
        Api.apiClient
      );

      const response =
        await client.contentEntities_myHighlightedContainer_get_V1(
          "1",
          body.SortBy,
          body.PageNumber,
          body.PageSize
        );

      if (response.success && response.data) {
        const { hasNextPage, totalCount, currentPage } = response;

        const dataObj = _.reduce(
          response.data,
          function (
            obj: { [key: string]: LibraryItemWithProgressOutput },
            param
          ) {
            if (param.id) obj[param.id] = param;

            return obj;
          },
          {}
        );

        const client = new Api.Server.Server_Sessions_Client(
          undefined,
          Api.apiClient
        );

        const progressResponse =
          await client.sessions_myContentProgresses_post_V1({
            contentEntityIds: response.data.map((l) => l.id!),
          });

        if (progressResponse.success && progressResponse.data) {
          for (const progress of progressResponse.data) {
            if (dataObj[progress.contentEntityId!]) {
              dataObj[progress.contentEntityId!] = {
                ...dataObj[progress.contentEntityId!],
                progress: progress.currentProgress,
              };
            }
          }

          return {
            data: Object.values(dataObj),
            meta: {
              hasNextPage,
              totalCount,
              currentPage,
            },
          };
        }

        return rejectWithValue(progressResponse.errors);
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const getBookmarkedDetails: ApiMethod<
  string,
  Api.Server.BookmarkedItemOutput[]
> = async (id, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_Bookmarks_Client(
          undefined,
          Api.apiClient
        );

        return client.bookmarks_byContainerContentEntityId_get_V1("1", id);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};

export const getHighlightedDetails: ApiMethod<
  string,
  Api.Server.HighlightOutput[]
> = async (id, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_Highlights_Client(
          undefined,
          Api.apiClient
        );

        return client.highlights_byContainerId_get_V1("1", id);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};

export const getMyCertificates: ApiMethod<
  void,
  Api.Server.GetB2BUserCertificatesOutput[]
> = async (_, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Api.Server.Server_Certificate_Client(
        undefined,
        Api.apiClient
      );

      const response = await client.certificate_myCertificates_get_V1();

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const getPlayLists: ApiMethod<
  void,
  Api.Server.PlaylistOutput[]
> = async (_, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Api.Server.Server_Playlists_Client(
        undefined,
        Api.apiClient
      );

      const response = await client.playlists_get_V1();

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const getPaginatedPlayLists: ApiMethod<
  LibraryProgressListContentInput,
  {
    data: Api.Server.PlaylistOutput[];
    meta: {
      hasNextPage: boolean | undefined;
      totalCount: number | undefined;
      currentPage: number | undefined;
    };
  }
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Api.Server.Server_Playlists_Client(
        undefined,
        Api.apiClient
      );

      const response = await client.playlists_paginated_get_V1(
        "1",
        body.SortBy,
        body.PageNumber,
        body.PageSize
      );

      if (response.success && response.data) {
        const { hasNextPage, totalCount, currentPage, data } = response;

        return {
          data,
          meta: {
            hasNextPage,
            totalCount,
            currentPage,
          },
        };
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const getPlayListById: ApiMethod<
  number | undefined,
  Api.Server.PlaylistOutput
> = async (id, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Api.Server.Server_Playlists_Client(
        undefined,
        Api.apiClient
      );

      const response = await client.playlists_byId_get_V1(undefined, id);

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const getPlayListItems: ApiMethod<
  number | undefined,
  Api.Server.PlaylistOutput
> = async (id, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Api.Server.Server_Playlists_Client(
        undefined,
        Api.apiClient
      );

      const response = await client.playlists_byId_get_V1(undefined, id);

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const createPlayList: ApiMethod<
  Api.Server.CreatePlaylistInput,
  Api.Server.PlaylistOutput
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Api.Server.Server_Playlists_Client(
        undefined,
        Api.apiClient
      );

      const response = await client.playlists_post_V1(body);

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const updatePlayList: ApiMethod<
  Api.Server.EditPlaylistInput,
  Api.Server.PlaylistOutput
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Api.Server.Server_Playlists_Client(
        undefined,
        Api.apiClient
      );

      const response = await client.playlists_put_V1(body);

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const removePlaylist: ApiMethod<
  number | undefined,
  Api.Server.AppResponse
> = async (id, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Api.Server.Server_Playlists_Client(
        undefined,
        Api.apiClient
      );

      const response = await client.playlists_delete_V1(id);

      if (response.success) {
        return response;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const addItemToPlaylist: ApiMethod<
  Api.Server.AddToPlaylistInput,
  Api.Server.AppResponse
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Api.Server.Server_Playlists_Client(
        undefined,
        Api.apiClient
      );

      const response = await client.playlists_add_post_V1(body);

      if (response.success) {
        return response;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};
export const removeItemFromPlaylist: ApiMethod<
  Api.Server.RemoveFromPlaylistInput,
  Api.Server.AppResponse
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Api.Server.Server_Playlists_Client(
        undefined,
        Api.apiClient
      );

      const response = await client.playlists_remove_post_V1(body);

      if (response.success) {
        return response;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const moveToPlaylist: ApiMethod<
  Api.Server.MoveToPlaylistInput,
  Api.Server.AppResponse
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Api.Server.Server_Playlists_Client(
        undefined,
        Api.apiClient
      );

      const response = await client.playlists_moveToPlaylist_put_V1(body);

      if (response.success) {
        return response;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const reArrangePlaylistItems: ApiMethod<
  Api.Server.ArrangePlaylistItemsInput,
  Api.Server.AppResponse
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Api.Server.Server_Playlists_Client(
        undefined,
        Api.apiClient
      );

      const response = await client.playlists_arrange_post_V1(body);

      if (response.success) {
        return response;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};
